app.controller('BaseController', ['$scope', '$window', '$location', '$interval', 'sessionService', 'WdHttpService', 'config', '$routeParams', 'textualContentSupply', 'analyticsService', 'tempStorageService',
    function ($scope, $window, $location, $interval, sessionService, WdHttpService, config, $routeParams, textualContentSupply, analyticsService, tempStorageService) {
        $scope.isUserLoggedIn = false;
        $scope.isQcLoggedIn = false;
        $scope.isPendingActionsAvailable = false;

        var refreshToken = sessionService.get("refresh");

        $scope.getBrokerName = async function () {
            if ($scope.isUserLoggedIn) {
                var cog_profile = await WdHttpService._cognito_profile(false);
                $scope.brokerName = getProfileValueFor("custom:brokerName1", cog_profile);
                if ($scope.brokerName) {
                    sessionService.set("brokerName", $scope.brokerName);
                    $scope.displayUserName = getProfileValueFor("name", cog_profile);
                    return $scope.brokerName;
                } else {
                    await $scope.prepareBrokerLinks($location.absUrl(), 'updateBrokerProfile', true, false);
                    $('#updateBroker').modal({ backdrop: 'static', keyboard: false });
                }
            }
            return undefined;
        }

        if (!sessionService.isLoggedIn()) {
            $scope.isUserLoggedIn = false;
            $("#pageLoader").css("z-index", "12");
        } else {
            $scope.isUserLoggedIn = true;
            $scope.getBrokerName();
            $("#pageLoader").css("z-index", "10");
        }

        if (!sessionService.isQcLoggedIn()) {
            $scope.isQcLoggedIn = false;
        } else {
            $scope.isQcLoggedIn = true;
        }
        $scope.otherBrokerSelected = false;

        $scope.pendingActions = {};

        $scope.getBrokersList = function () {
            return config.BROKERS;
        }

        $scope.logOut = async function () {
            if ($scope.brokerName && $scope.brokerName.toUpperCase() == "ZERODHA") {
                var currentBrokerHomePage = config[$scope.brokerName.toUpperCase()].brokerPage;
                currentBrokerHomePage = currentBrokerHomePage.substring(0, currentBrokerHomePage.lastIndexOf("/") + 1)
                await analyticsService._push_custom_event_data_to_datalayer('user-logout', {});
                removeLocalSession();
                window.location.href = currentBrokerHomePage + '?action=logout' + '&path=' + window.location.origin;
            } else {
                await analyticsService._push_custom_event_data_to_datalayer('user-logout', {});
                removeLocalSession();
                $location.path("/");
            }
        }
        $scope.getAllPendingAction = async function () {
            await WdHttpService._get_all_pending_actions(true)
                .then(function (response) {
                    if (response.data.hasOwnProperty('pendingOrderIds')) {
                        if (response.data.pendingOrderIds.length > 0)
                            $scope.pendingActions = response.data.pendingOrderIds ? response.data.pendingOrderIds : [];
                        if (Object.keys($scope.pendingActions).length == 0) {
                            $scope.isPendingActionsAvailable = false;
                        } else {
                            $scope.isPendingActionsAvailable = true;
                        }
                    }
                }).catch(error => {
                    console.log(error);
                });
        };

        $scope.agreementSigningforPendingUsers = async function (returnPath = undefined) {
            if ('DO_AGREEMENT_FOR' in config) {
                if (config.DO_AGREEMENT_FOR.length > 0) {
                    let userDDBprofile = await WdHttpService._get_dynamodb_user_profile();

                    for (let index = 0; index < config.DO_AGREEMENT_FOR.length; index++) {
                        const adviserUsername = config.DO_AGREEMENT_FOR[index];
                        let result = await $scope.checkAdviserAgreement(userDDBprofile ? userDDBprofile.advisorToFunds : [], adviserUsername);
                        if (result.redirectUrl && result.message) {
                            $scope.showMessagePopup(result.message, 'Please complete your adviser agreement signing', () => window.location.href = result.redirectUrl);
                            return;
                        }
                    }
                    if (returnPath) {
                        $location.path(returnPath);
                    }
                }
            }
        }

        // check if the user has signed the agreement with adviser or not
        $scope.checkAdviserAgreement = async function (subscribedFunds, adviserUsername) {
            let returnResult = {};
            const subscribedFund = subscribedFunds.find(fund => fund.adviserUsername == adviserUsername);
            if (subscribedFund) {
                $scope.doAgreementStatusCheck = await WdHttpService._get_user_adviser_analyst_agreement_status(adviserUsername);
                if ($scope.doAgreementStatusCheck == "NOT_SIGNED") {
                    let ifAdviserResearchAnalyst = await $scope.checkIfResearchAnalyst(subscribedFund.fund);
                    if (ifAdviserResearchAnalyst) {
                        returnResult.redirectUrl = '/adviser-agreement/' + adviserUsername + '/' + subscribedFund.fund;
                        returnResult.message = "Your agreement signing with adviser is pending, redirecting you to sign the agreement.";
                    } else {
                        $scope.userRiskValue = await $scope.isRiskProfileDone();
                        tempStorageService.set('agreementSigningforPendingUsers', 'true');
                        if (!$scope.userRiskValue) {
                            returnResult.redirectUrl = '/risk-profile?next=agreement&adviserUsername=' + adviserUsername + '&fundName=' + subscribedFund.fund;
                            returnResult.message = "Your risk profilling and agreement signing with adviser is pending, redirecting you to fill in the required data.";
                        } else {
                            returnResult.redirectUrl = '/adviser-agreement/' + adviserUsername + '/' + subscribedFund.fund;
                            returnResult.message = "Your agreement signing with adviser is pending, redirecting you to sign the agreement.";
                        }
                    }
                }
            }
            return returnResult;
        }

        // check for risk profile and redirect if needed
        $scope.isRiskProfileDone = async function () {
            var cognitoProfile = await WdHttpService._cognito_profile();
            return getProfileValueFor('custom:risk', cognitoProfile);
        }

        $scope.checkIfResearchAnalyst = async function (fundName) {
            let isResearchAnalyst = undefined;
            var data = {
                q: "fundName:" + fundName,
                f: "web_admin:" + $scope.webadminName
            }
            await WdHttpService._get_funds(data)
                .then(async function (response) {
                    if (response.status == 200) {
                        var fund_details;
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == fundName)
                                    fund_details = fund;
                            });
                        } else
                            fund_details = response.data.Items[0];
                        isResearchAnalyst = fund_details.wealthBasketType == 'RA' ? true : false;
                    }
                }).catch(error => {
                    console.log(error);
                });
            return isResearchAnalyst;
        }

        function removeLocalSession() {
            $scope.isUserLoggedIn = false;
            sessionService.remove('refresh');
            sessionService.remove('auth');
            sessionService.remove('id');
            sessionService.remove('name');
            sessionService.remove('username');
            sessionService.remove('expiresIn');
            sessionService.remove('qcExpiresIn');
            sessionService.remove('mode');
            sessionService.remove('qcLogin');
            sessionService.remove('profile');
            sessionService.remove('cognito_username');
            sessionService.remove('brokerName');
            sessionService.remove('investingMode');
            sessionService.remove('transactionId');
            sessionService.remove('transactionIdOrders');
            sessionService.remove('stopApprovalReminder');
        }

        $scope.homeClick = function () {
            $location.path("/");
        }

        $scope.showPageLoader = function (text = undefined) {
            if (text) {
                $('#loaderText').text(text);
            } else {
                $('#loaderText').text("Loading...");
            }
            $('#pageLoader').show();
            $('#pageLoader > div').show();
            $('#loaderText').show();
        }

        $scope.hidePageLoader = function () {
            $('#pageLoader').hide();
            $('#pageLoader > div').hide();
            $('#pageLoader > p').hide();
            $scope.$evalAsync();
        }

        $scope.showSuccessPopup = function (message, callback = undefined) {
            if (typeof message == 'string')
                $scope.successMessage = message;
            else
                $scope.successMessage = undefined;
            $('#doneSuccessfully').modal('show');

            if (callback) {
                $('#doneSuccessfully').on('hide.bs.modal', callback);
            }
        }

        $scope.showRefreshPopup = function (message) {
            if (typeof message == 'string')
                $scope.refreshMessage = message;
            else
                $scope.refreshMessage = "Sorry! something went wrong, please try after sometime.";
            $('#refreshPage').modal('show');
        }

        $scope.showProcessingPopup = function (message) {
            if (typeof message == 'string')
                $scope.processingMessage = message;
            else
                $scope.processingMessage = "Sorry! something went wrong, please try after sometime.";
            $('#processingPage').modal('show');
        }

        $scope.showErrorPopup = function (error, callback = undefined, isError = true, header = undefined) {
            if (typeof header == 'string')
                $scope.errorHeader = header;
            else
                $scope.errorHeader = "Sorry";

            if (typeof error == 'string')
                $scope.errorHandleMessage = error;
            else
                $scope.errorHandleMessage = "Sorry! something went wrong, please try after sometime.";

            $scope.isError = isError;
            $('#somethingWrong').modal('show');
            $scope.$evalAsync();
            if (callback) {
                $('#somethingWrong').on('hide.bs.modal', callback);
            }
        }

        $scope.showMessagePopup = function (message, title = '', callback = undefined) {
            if (typeof message == 'string')
                $scope.messageBoxString = message;
            else
                $scope.messageBoxString = JSON.stringify(message);

            if (typeof title == 'string') {
                $scope.messageTitle = title;
            }

            $('#messagebox').modal('show');
            $scope.$evalAsync();
            if (callback) {
                $('#messagebox').on('hide.bs.modal', callback);
            }
        }

        $scope.reloadRoute = function () {
            $window.location.reload();
        }

        $scope.stopLoading = function (selector) {
            $(selector).prop('disabled', false);
            angular.element(document.querySelector(selector + " > div.lds-ellipsis")).removeClass("dw-inline-block");
            angular.element(document.querySelector(selector + " > span.dw-sign-btn")).removeClass("dw-none");
            $scope.$evalAsync();
        }

        $scope.showLoading = function (selector) {
            $(selector).prop('disabled', true);
            angular.element(document.querySelector(selector + " > div.lds-ellipsis")).addClass("dw-inline-block");
            angular.element(document.querySelector(selector + " > span.dw-sign-btn")).addClass("dw-none");
        }

        $('[data-toggle="tooltip"]').tooltip();

        $scope.interval = $interval(function () {
            $scope.checkForRefresh();
        }, 60 * 1000);

        $scope.checkForRefresh = function () {
            if (sessionService.get('expiresIn') != undefined) {
                if (sessionService.get('expiresIn') - new Date().getTime() <= 5 * 60 * 1000)
                    $scope.refresh();
            }
        }

        $scope.refresh = function () {
            if (refreshToken != undefined || refreshToken != null) {
                var data = { refreshToken: refreshToken };
                WdHttpService._refresh_token(data)
                    .then(async function (response) {
                        setUserSession(sessionService, response);

                        await WdHttpService._qc_login();

                        var cog_profile = await thisClass._cognito_profile(false);
                        var brokerName = getProfileValueFor("custom:brokerName1", cog_profile);
                        if (brokerName) {
                            sessionService.set("brokerName", brokerName);
                        } else {
                            await $scope.prepareBrokerLinks($location.absUrl(), 'updateBrokerProfile', true, false);
                            $('#updateBroker').modal({ backdrop: 'static', keyboard: false });
                        }
                        sessionService.set("investingMode", "REAL");
                    });
            }
        };

        $scope.init = async function () {
            var distributorName = $location.search().dbn;
            if (distributorName) {
                sessionService.set("distributorName", distributorName);
            }
            if (!$scope.brokerName) {
                await $scope.getBrokerName();
            }
            sessionService.set('investingMode', 'REAL');
            $scope.investingMode = 'REAL';
            $scope.real_money = true;

            if ($scope.brokerName) {
                $scope.selectedBroker = $scope.brokerName;
            }

            if (sessionService.isLoggedIn()) {
                $scope.isOfflineBroker = await $scope.checkIsUserBrokerOffline();
                $scope.investingMode = sessionService.get("investingMode");
                if (!sessionService.get('distributorMapped') && sessionService.get("distributorName")) {
                    var data = {
                        distributorName: sessionService.get("distributorName"),
                        brokerName: sessionService.get("brokerName"),
                        registrationTimestamp: Date.now()
                    }

                    WdHttpService.add_investor(data)
                        .then(response => {
                            // console.log(response);
                            sessionService.set('distributorMapped', 'true');
                        }).catch(error => {
                            $scope.showErrorPopup(error);
                        });
                }
                var data = {
                    investingMode: $scope.investingMode,
                    brokerAuthentication: {
                        "sessionId": sessionService.get("brokerName"),
                        "transactionId": JSON.stringify({
                            "groupId": "",
                            "sessionId": "",
                            "transactionId": ""
                        })
                    }
                };
                $scope.getAllPendingAction();
                $scope.checkUploadTradeOfflineBroker();
            }
        }

        $scope.failedEnachPaymentChecker = async function () {
            await WdHttpService._get_pending_payments()
                .then(response => {
                    enachFailedPayments = response.filter(pendingPayment => pendingPayment.purpose.startsWith("ENACH"));
                    if (enachFailedPayments.length > 0) {
                        $('#failedEnachPaymentModel').modal('show');
                    }
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.hidePageLoader();
                })

        }

        $scope.redirectPendingAction = function () {
            $('#failedEnachPaymentModel').modal('hide');
            $(".modal-backdrop").remove();
            window.location.href = '/wealthbasket-revision?tab=payment';
        }

        $scope.otherBrokerSelection = function () {
            $scope.otherBrokerSelected = true;
        }

        $scope.offlineBrokerList = function () {
            if (config.OFFLINE_BROKERS) {
                var brokerDropdownDown = {}
                var offlineBrokerList = config.OFFLINE_BROKERS;
                offlineBrokerList.sort();
                offlineBrokerList.forEach(broker => {

                    if (broker != 'WD')
                        brokerDropdownDown[broker] = broker
                    else
                        brokerDropdownDown['WD'] = 'Other | Not Listed';
                });
                return brokerDropdownDown;
            } else {
                return { 'WD': 'others' }
            }
        }

        $scope.intiateBrokersList = async function () {
            $scope.setBrokersList();
            $scope.brokerMap = {}
            $scope.brokerList.forEach(broker => {
                $scope.brokerMap[broker] = {};
                $scope.brokerMap[broker]['logoUrl'] = config[broker].logoUrl;
                if ($scope.redirectValue)
                    $scope.brokerMap[broker]['brokerPage'] = config[broker].brokerPage + '?brokerName=' + broker + '&path=' + window.location.origin + '/' + $scope.redirectValue + '&returnToken=true';
                else
                    $scope.brokerMap[broker]['brokerPage'] = config[broker].brokerPage + '?brokerName=' + broker + '&path=' + window.location.origin + '&returnToken=true';
                $scope.brokerMap[broker]['brokerName'] = config[broker].brokerName;
            });

            $scope.odinBrokerlist = $scope.getOdinBrokersList();
            $scope.odinBrokerlist.forEach(broker => {
                $scope.brokerMap[broker] = {};
                $scope.brokerMap[broker]['logoUrl'] = config[broker].logoUrl;
                $scope.brokerMap[broker]['brokerPage'] = config[broker].brokerPage + '?brokerName=' + broker + '&path=' + window.location.origin + '&returnToken=true';
                $scope.brokerMap[broker]['brokerName'] = config[broker].brokerName;
            });

            // Adding Additional Seperately
            $scope.addBrokerlist = await $scope.getAdditionalBrokersList();
            $scope.addBrokerlist.forEach(broker => {
                $scope.brokerMap[broker] = {};
                $scope.brokerMap[broker]['logoUrl'] = config[broker].logoUrl;
                $scope.brokerMap[broker]['brokerPage'] = config[broker].brokerPage + '?brokerName=' + broker + '&path=' + window.location.origin + '&returnToken=true';
                $scope.brokerMap[broker]['brokerName'] = config[broker].brokerName;
            });
            $scope.odinBrokerlist = $scope.odinBrokerlist.concat($scope.addBrokerlist.filter((item) => $scope.odinBrokerlist.indexOf(item) < 0));
            // Adding WD Seperately
            $scope.brokerMap['WD'] = {};
            $scope.brokerMap['WD']['logoUrl'] = config['WD'].logoUrl;
            $scope.brokerMap['WD']['brokerPage'] = config['WD'].brokerPage;
            $scope.brokerMap['WD']['brokerName'] = config['WD'].brokerName;
            $scope.orderedBrokers = $scope.brokerList.concat($scope.odinBrokerlist.filter((item) => $scope.brokerList.indexOf(item) < 0));
            let brokerOrdering = config['BROKER_ORDERING'] ? config['BROKER_ORDERING'] : [];


            if (!$scope.orderedBrokers.includes("WD"))
                $scope.orderedBrokers.push('WD');

            $scope.orderedBrokers.sort(function (a, b) {
                var otherBroker = 'WD';

                if (a === otherBroker) {
                    return 1;
                } else if (b === otherBroker) {
                    return -1;
                }
                if (brokerOrdering.includes(a) || brokerOrdering.includes(b)) {
                    let indexA = brokerOrdering.indexOf(a) == -1 ? 100 : brokerOrdering.indexOf(a);
                    let indexB = brokerOrdering.indexOf(b) == -1 ? 100 : brokerOrdering.indexOf(b);
                    return indexB > indexA ? -1 : 1;
                }
                return a > b ? 1 : -1;
            });
        }

        $scope.setBrokersList = function () {
            if ($scope.activeBrokersList && $scope.activeBrokersList.length > 0) {
                $scope.brokerList = $scope.activeBrokersList;
            } else {
                $scope.brokerList = config.BROKERS ? config.BROKERS : [];
            }
        }

        $scope.getOdinBrokersList = function () {
            return config.ODINBROKERS ? config.ODINBROKERS : [];
        }

        $scope.getAdditionalBrokersList = function () {
            return $scope.additionalBrokersList ? $scope.additionalBrokersList : [];
        }

        $scope.sendToBrokerUrl = async function (pageName) {
            var cog_profile = await WdHttpService._cognito_profile(false);
            var sendToBrokerUrl = '';
            if (cog_profile) {
                var brokerName = getProfileValueFor("custom:brokerName1", cog_profile);
                if (brokerName) {
                    brokerName = brokerName.toUpperCase();

                    if (config[brokerName].brokerPage)
                        sendToBrokerUrl = config[brokerName].brokerPage;
                    else {
                        $scope.showErrorPopup('Your broker deployment are not found. Please connect to our support team at team@wealthtech.in with NAF' + brokerName + ' error code');
                        return;
                    }
                }
                if (pageName && brokerName) {
                    $window.location.href = sendToBrokerUrl + '?action=' + pageName;
                } else if (brokerName) {
                    $window.location.href = sendToBrokerUrl;
                }
            } else {
                $scope.prepareBrokerLoginModal(pageName, false);
            }
        }

        $scope.loginRedirectUrl = function (value) {

            var redirectValue;
            var queryStrings = {};
            var isExternalUrl = true;
            if (value == 'kyc') {
                redirectValue = 'kyc';
                queryStrings = {
                    'fund': $routeParams.fundname
                }
                isExternalUrl = false;
            } else if (value == 'fund-detail') {
                redirectValue = 'fund-details/' + $routeParams.fundname;
            }


            if ($scope.isUserLoggedIn && !isExternalUrl) {
                $location.path(redirectValue).search(queryStrings);
            } else if (!$scope.isUserLoggedIn) {
                if (queryStrings != {}) {
                    redirectValue += '?';
                    for (const key in queryStrings) {
                        if (queryStrings.hasOwnProperty(key)) {
                            const value = queryStrings[key];
                            redirectValue += key + '=' + value;
                        }
                    }
                }
                $scope.prepareBrokerLoginModal(redirectValue, true);
            } else if ($scope.isUserLoggedIn && isExternalUrl) {
                window.location.href = config[$scope.brokerName].brokerPage + '?action=' + redirectValue;
            }
            $scope.$evalAsync();
        }

        /**
         * 
         * @param {*} redirectPath - Specify the path where the user shall be redirected to after successfull Login is done.
         * @param {*} action - Specify any action to be performed on the broker deployment end or redirect to an internal link of broker deployment once logged in.
         * @param {*} returnToken - Whether the Cognito token is required to be carried forward/send back to us
         * @param {*} sendCurrenToken - Whether our session token shall be send or not
         */

        $scope.prepareBrokerLinks = function (redirectPath = undefined, action = undefined, returnToken = true, sendCurrentToken = true) {
            $scope.brokerMap = {};
            if (!$scope.orderedBrokers) {
                $scope.orderedBrokers = [];
            }
            $scope.orderedBrokers.forEach(broker => {
                if (!$scope.brokerMap[broker]) $scope.brokerMap[broker] = {};
                $scope.brokerMap[broker]['logoUrl'] = config[broker].logoUrl;
                $scope.brokerMap[broker]['brokerName'] = config[broker].brokerName;
                if (redirectPath)
                    $scope.brokerMap[broker]['brokerPage'] = config[broker].brokerPage + "?path=" + redirectPath + "&";
                else
                    $scope.brokerMap[broker]['brokerPage'] = config[broker].brokerPage + "?";

                if (returnToken)
                    $scope.brokerMap[broker]['brokerPage'] += "returnToken=true&";

                if (action)
                    $scope.brokerMap[broker]['brokerPage'] += "action=" + action + "&";

                if (sendCurrentToken && sessionService.isLoggedIn()) {
                    $scope.brokerMap[broker]['brokerPage'] += "token=" + sessionService.get("refresh");
                }
            });
        }

        $scope.updateBroker = function (form) {
            if (form.brokerName.$modelValue) {
                // TODO Ask for client Code or not ?
                var data = {
                    "clientCode": "",
                    "panCard": "",
                    "phoneNumber": "",
                    "brokerName": form.brokerName.$modelValue,
                    "email": "",
                }
                $scope.showLoading("#selectBrokerContinueButton");
                WdHttpService._update_profile(data)
                    .then(async function (response) {
                        $scope.stopLoading("#selectBrokerContinueButton");
                        $('#updateBroker').modal('hide');
                        WdHttpService._cognito_profile(true);
                        $scope.showSuccessPopup("Congratulations, you've successfully updated your Broker. Happy Investing");
                        var actionPage = $location.search().action;
                        var path = $location.search().path;
                        if (actionPage) {
                            $scope.sendToActionPage(actionPage);
                        } else if (path) {
                            $scope.handleRedirectionPath(path);
                        } else {
                            $('#doneSuccessfully').on('hide.bs.modal', () => window.location.href = '/');
                        }
                    }).catch(error => {
                        console.log(error);
                        $scope.showRegisterError(error);
                        $scope.stopLoading("#selectBrokerContinueButton");
                    });
            } else {
                $scope.showErrorPopup("Broker selection is required.");
            }
        }

        $scope.prepareBrokerLoginModal = async function (redirectPath, shallRedirectBack = true) {
            if (!redirectPath && shallRedirectBack) {
                redirectPath = $location.absUrl();
            }

            await $scope.prepareBrokerLinks(redirectPath, undefined, true, false);
            await $('#confirmBroker').modal('show');
        }

        $scope.adviserDetails = undefined;

        $scope.fetchAdviserSiteDetails = async function () {
            if ($scope.adviserDetails == undefined) {
                var host = $location.host();
                var subdomain = undefined;
                var distributorUsername = undefined;
                var parts = [];

                if (host.includes("."))
                    parts = host.split('.');

                if (parts.length > 2)
                    subdomain = parts[0];
                else if ($routeParams.adviser) {
                    subdomain = $routeParams.adviser;
                    distributorUsername = $routeParams.adviser;
                } else {
                    for (const key in config.ADVISERSMETADATA) {
                        if (config.ADVISERSMETADATA.hasOwnProperty(key)) {
                            distributorUsername = key;
                            subdomain = config.ADVISERSMETADATA[key].subdomain;
                            $scope.webadminName = config.ADVISERSMETADATA[key].webadminName;
                            $scope.type = config.ADVISERSMETADATA[key].type ? config.ADVISERSMETADATA[key].type : 'distributor';
                            $scope.blogUrl = config.ADVISERSMETADATA[key].blogUrl ? config.ADVISERSMETADATA[key].blogUrl : undefined;
                            $scope.productName = config.ADVISERSMETADATA[key].productName ? config.ADVISERSMETADATA[key].productName : 'WealthBasket';
                            $scope.landingImage = config.ADVISERSMETADATA[key].landingImage ? config.ADVISERSMETADATA[key].landingImage : '/assets/img/wealthDesk-main-mob.svg';
                            $scope.fbLink = config.ADVISERSMETADATA[key].fbLink ? config.ADVISERSMETADATA[key].fbLink : '';
                            $scope.linkedinLink = config.ADVISERSMETADATA[key].linkedinLink ? config.ADVISERSMETADATA[key].linkedinLink : '';
                            $scope.instaLink = config.ADVISERSMETADATA[key].instaLink ? config.ADVISERSMETADATA[key].instaLink : '';
                            $scope.twitterLink = config.ADVISERSMETADATA[key].twitterLink ? config.ADVISERSMETADATA[key].twitterLink : '';
                            $scope.footerLogo = config.ADVISERSMETADATA[key].footerLogo ? config.ADVISERSMETADATA[key].footerLogo : '';
                            $scope.header2 = config.ADVISERSMETADATA[key].header2 ? config.ADVISERSMETADATA[key].header2 : 'Each portfolio is a research backed mix of stocks or ETFs which gives you a diversified portfolio with improved performance.';
                            $scope.activeBrokersList = config.ADVISERSMETADATA[key].activeBrokers ? config.ADVISERSMETADATA[key].activeBrokers : [];
                            $scope.additionalBrokersList = config.ADVISERSMETADATA[key].additionalBrokers ? config.ADVISERSMETADATA[key].additionalBrokers : [];
                            $scope.postPayMessage = config.ADVISERSMETADATA[key].postPayMessage ? config.ADVISERSMETADATA[key].postPayMessage : '';
                            $scope.header3 = config.ADVISERSMETADATA[key].header3 ? config.ADVISERSMETADATA[key].header3 : 'come in various forms. They can be long term, short term, sectoral, thematic, active or passive.';
                            $scope.header4 = config.ADVISERSMETADATA[key].header4 ? ADVISERSMETADATA[key].header4 : '';
                            $scope.showCompareBasketFeature = "showCompareBasketFeature" in config.ADVISERSMETADATA[key] ? ADVISERSMETADATA[key].showCompareBasketFeature : false;
                            $scope.showSocialMediaShareButtons = "showSocialMediaShareButtons" in config.ADVISERSMETADATA[key] ? ADVISERSMETADATA[key].showSocialMediaShareButtons : true;
                            $scope.hideMobileLogo = 'hideMobileLogo' in config.ADVISERSMETADATA[key] ? config.ADVISERSMETADATA[key]['hideMobileLogo'] : false;
                            $scope.hideMobileFaqIcon = 'hideMobileFaqIcon' in config.ADVISERSMETADATA[key] ? config.ADVISERSMETADATA[key]['hideMobileFaqIcon'] : false;
                            $scope.hideLogoutButton = 'hideLogoutButton' in config.ADVISERSMETADATA[key] ? config.ADVISERSMETADATA[key]['hideLogoutButton'] : false;
                            break;
                        }
                    }
                }

                for (const key in config.ADVISERSMETADATA) {
                    if (config.ADVISERSMETADATA.hasOwnProperty(key)) {
                        if (config.ADVISERSMETADATA[key].subdomain == subdomain) {
                            distributorUsername = key;
                            $scope.webadminName = config.ADVISERSMETADATA[key].webadminName;
                            $scope.type = config.ADVISERSMETADATA[key].type ? config.ADVISERSMETADATA[key].type : 'distributor';
                            $scope.blogUrl = config.ADVISERSMETADATA[key].blogUrl ? config.ADVISERSMETADATA[key].blogUrl : undefined;
                            $scope.productName = config.ADVISERSMETADATA[key].productName ? config.ADVISERSMETADATA[key].productName : 'WealthBasket';
                            $scope.landingImage = config.ADVISERSMETADATA[key].landingImage ? config.ADVISERSMETADATA[key].landingImage : '/assets/img/wealthDesk-main-mob.svg';
                            $scope.fbLink = config.ADVISERSMETADATA[key].fbLink ? config.ADVISERSMETADATA[key].fbLink : '';
                            $scope.linkedinLink = config.ADVISERSMETADATA[key].linkedinLink ? config.ADVISERSMETADATA[key].linkedinLink : '';
                            $scope.instaLink = config.ADVISERSMETADATA[key].instaLink ? config.ADVISERSMETADATA[key].instaLink : '';
                            $scope.twitterLink = config.ADVISERSMETADATA[key].twitterLink ? config.ADVISERSMETADATA[key].twitterLink : '';
                            $scope.footerLogo = config.ADVISERSMETADATA[key].footerLogo ? config.ADVISERSMETADATA[key].footerLogo : '';
                            $scope.header2 = config.ADVISERSMETADATA[key].header2 ? config.ADVISERSMETADATA[key].header2 : 'Each portfolio is a research backed mix of stocks or ETFs which gives you a diversified portfolio with improved performance.';
                            $scope.activeBrokersList = config.ADVISERSMETADATA[key].activeBrokers ? config.ADVISERSMETADATA[key].activeBrokers : [];
                            $scope.additionalBrokersList = config.ADVISERSMETADATA[key].additionalBrokers ? config.ADVISERSMETADATA[key].additionalBrokers : [];
                            $scope.postPayMessage = config.ADVISERSMETADATA[key].postPayMessage ? config.ADVISERSMETADATA[key].postPayMessage : '';
                            $scope.header3 = config.ADVISERSMETADATA[key].header3 ? config.ADVISERSMETADATA[key].header3 : 'come in various forms. They can be long term, short term, sectoral, thematic, active or passive.';
                            $scope.header4 = config.ADVISERSMETADATA[key].header4 ? ADVISERSMETADATA[key].header4 : '';
                            $scope.showCompareBasketFeature = "showCompareBasketFeature" in config.ADVISERSMETADATA[key] ? ADVISERSMETADATA[key].showCompareBasketFeature : false;
                            $scope.showSocialMediaShareButtons = "showSocialMediaShareButtons" in config.ADVISERSMETADATA[key] ? ADVISERSMETADATA[key].showSocialMediaShareButtons : true;
                            $scope.hideMobileLogo = 'hideMobileLogo' in config.ADVISERSMETADATA[key] ? config.ADVISERSMETADATA[key]['hideMobileLogo'] : false;
                            $scope.hideMobileFaqIcon = 'hideMobileFaqIcon' in config.ADVISERSMETADATA[key] ? config.ADVISERSMETADATA[key]['hideMobileFaqIcon'] : false;
                            $scope.hideLogoutButton = 'hideLogoutButton' in config.ADVISERSMETADATA[key] ? config.ADVISERSMETADATA[key]['hideLogoutButton'] : false;
                            break;
                        }
                    }
                }

                if (distributorUsername == undefined) {
                    $location.path('/page-not-found');
                    return;
                } else {
                    SITE_ROOT = 'https://' + subdomain + '.wealthdesk.in/';
                }
                $scope.distributorUsername = distributorUsername;
                if (!$scope.distributorUsername) {
                    $location.path('/');
                }

                $scope.isAdviser = false;
                $scope.isDistributor = false;
                if ($scope.type === "adviser") {
                    $scope.isAdviser = true;
                } else if ($scope.type === "distributor") {
                    $scope.isDistributor = true;
                    sessionService.set("distributorName", distributorUsername);
                }

                //call the adviser page details
                $scope.adviserDetails = await WdHttpService._get_entity_page_details({ adviserUsername: $scope.distributorUsername });
                if ('custom:metadata' in $scope.adviserDetails && $scope.adviserDetails['custom:metadata']) {
                    "isRIA" in $scope.adviserDetails['custom:metadata'] ? $scope.isAdviserResearchAnalyst = $scope.adviserDetails['custom:metadata'].isRIA == 'RA' : false;
                } else {
                    $scope.isAdviserResearchAnalyst = false;
                }
                $scope.faqUrl = config.ADVISERSMETADATA[$scope.distributorUsername].faqUrl ? config.ADVISERSMETADATA[$scope.distributorUsername].faqUrl : $scope.isAdviserResearchAnalyst ? 'https://wdpages.s3.ap-south-1.amazonaws.com/raadviserfaqs.json' : 'https://s3.ap-south-1.amazonaws.com/wdpages/adviserfaqs.json';
            }

            await $scope.intiateBrokersList();

            //handle the token to get signed in           
            var token = $location.search().token;
            // if (!$scope.isUserLoggedIn) {
            //     // For local testing only
            //     token = 'eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.YGADi2iQrIXgoFFlG2PXxsayyjL5AlOmvtazLWUqBgfXfDGeBAAI3NylkYu_5IckB4jFXDSfYx9WCmIZP3FNDgxQLhrzKFs5KOSgO_GP5yxxUnuddzckn9IYcalXMAMlR-YKr2iadZUtlYwSs2z01EJufQTWd7gSBH1rIB9hMFnUvTo-KEdigzio4CeYITWtl9-sUfOnFA3Sn1U-WJhLpAbpmCUhCAvm4tnl-oHm05bYN3-NQrM5hiF_WeLs_rsO_KkrsdvV1Bgz0gel5-EdRZeZiY-ILZXBfue4fGM9wPOkvb2LnqJLvQoGKaEQ3ueZuIsUwVdm8Crv3aNo0FX3HA.wHw9jsp3rqU9m-nh.Q5QkPOTu6gF5rU1ZLgPWZKpLDqVJ3seCM2XdcAoiP9rhf2yywA7SkKr7QyA-CNihnnX8kABm_PCmJujHXJ3dBozAe95rJRJkRhYRtmUDatfWQ3jGIk0XOuF7jgdQQ6rRLL00QLajJvXkGStCRkU2gFUvrGO8RQxW-8cWTpHtmPplR2UO9iXvOXRN-QluX8W4FffIpo4G7XNdUDmkC9fNk3LcBUNylbYMR3VlYRCijHI0At42OwJ23dHGmKBLoTqBC_0mJH6HRaYMiKBwpdT0McuphBN5kYSbpAniMK6EL44MfFNNKoycT1VEoOzOmeo-dV_t8EYhZe0BKRvQNJLxdQwr9xlalBOxqO-wgOmxsPxX3uaQAcHoKq_dsJckn1Q_kT_9NI2xBI1hMrPbTvFVaB4lWkljMJJAfjaAzVJEFVU2y3Lrip8YWuL4YRAvuPLIGtMyTk_3HbeqXjzXD1JW2-Ov_2EpU2ySvQBulwf9po11P3vrYZarLryY7xf9XGzDqXRJoFbwT5RwCjeGiPpyhlTcxu0ho4j6yR7KoQ_-t4mvOf2Yey2pyLCNgcZtBVlYhNITS6YG7DowM1RkIcyUo3VjPtG7oo8rNqFLXPzMfBGUYd0GV5ndLLBpduKJJxReA9c0hHoVooChnGPCsWPB2iwgV6ATb40Y1tnxLnztH5yEdmQ8ETRNyzNwXpeu2QY6PoLVuV_6NevAu1H2yhoJF9_K6SORrq-bcqQB2ZIMpQdO2XOAH_jqgMXO2CTcvcB4w_k8L70lMrGC_2NEi_mQ5znzZ0cNjxFdxNgnsEsh7FGTh-rSjRdPtAQG-baXhz2ug-1s1QU1VhZw8I_o33QlO0Q1rkDsfZTO11Cxeie3hrBXBbCPGGr1LKPwADdrJwgh250dnDrpkDDSqb-xe4IP0fMiTS13GSGV6x10deO_caKh12_j0zDLpfEj9Ck7YVPYQO94WCQCQMMjAL55qzJ46b-CxguL7UjDuZWFWQVb2NEH51YDyXAyqDCg4WJaeYc2tl_0aqruFlw9TP1gDYkWEaKCeeE3fwklxG4UF7Rao8HGvW9tarIOj1lK_bERWk_WDy796XiHiLee_6oyjG7-EEtzBbg4-dirJmfopCO35qEhr4hTmWpUdp3FSGp5Sfv7uscHzoXLR8udoPtufVkG2j27CNuH8gr3sE5e2Wu3cvtruNKKpMC7h-ChxuGO_tAJiT6IUPP8i8kjGI96i96uTFv-6TnyhqZ6L1y39vOhRZXJd5ndVZPyVwYkrV-5QYHYfOVua4de7bgXVhgtonUZzflcaDKy.1KHD6kC0vV8RDgdODeDeVQ';
            // }

            if (token && token !== 'null') {
                if (sessionService.isLoggedIn()) {
                    removeLocalSession();
                }
                sessionService.set('refresh', token);

                var data = { 'refreshToken': sessionService.get('refresh') }
                $scope.showPageLoader();
                await WdHttpService._refresh_token(data, true)
                    .then(async function (response) {
                        setUserSession(sessionService, response);

                        await WdHttpService._cognito_profile(false);
                        analyticsService._push_custom_event_data_to_datalayer('broker-login', {});

                        $scope.hidePageLoader();
                        $location.search('token', null); // remove the cred info
                        $window.location.href = $location.absUrl(); // reload the page for user session and header
                    })
                    .catch(async function (error) {
                        console.log(error);
                        $scope.hidePageLoader();
                        await $scope.showErrorPopup('Sorry, we failed to authenticate you.', () => { window.location.href = '/'; });
                    });
            }
        }

        $scope.generateTermsOfServiceText = function () {
            var htmlText = textualContentSupply._terms_of_service_content();
            htmlText = htmlText.replace('_SUBDOMAIN_', config.ADVISERSMETADATA[$scope.distributorUsername].subdomain);
            htmlText = htmlText.replace('ADVISER_EMAIL', $scope.adviserDetails['email']);
            htmlText = htmlText.split('_COMPANY_NAME_').join($scope.adviserDetails['custom:company']);
            return htmlText;
        }

        $scope.setUserSession = function (sessionService, response) {
            sessionService.set("auth", JSON.stringify(response.data.authenticationResult.accessToken));
            sessionService.set("id", JSON.stringify(response.data.authenticationResult.idToken));
            sessionService.set("refresh", JSON.stringify(response.data.authenticationResult.refreshToken), 30);
            var expireIn = parseInt(response.data.authenticationResult.expiresIn) * 1000 + parseInt(new Date().getTime());
            sessionService.set("expiresIn", expireIn + "");
        }

        $scope.redirectUploadTrades = async function (modalId = undefined) {

            if (modalId) {
                $(modalId).modal('hide');
            }
            $("body").removeClass("modal-open");
            $(".modal-backdrop").remove();
            await analyticsService._push_custom_event_data_to_datalayer('redirecting-to-upload-trade', {});
            $location.path('/upload-trades').search({});
            $scope.showPageLoader();
            $scope.$evalAsync();
        }

        $scope.checkIsUserBrokerOffline = async function () {
            var investingMode = sessionService.get("investingMode");
            if (investingMode == 'REAL') {
                var profile = await WdHttpService._cognito_profile(false);
                if (profile) {
                    var brokerName = getProfileValueFor('custom:brokerName1', profile);
                    if (brokerName)
                        if (config.OFFLINE_BROKERS.includes(brokerName))
                            return true;
                }
            }
            return false;
        }

        $scope.downloadStockList = function (data, filename) {
            var csvData = [];
            data.forEach(order => {
                var rowData = [];
                rowData.push(order.share);
                rowData.push(order.adviseType);
                rowData.push(order.exchange);
                rowData.push(order.sharesQuantity);
                rowData.push(order.price);
                csvData.push(rowData);
            })
            downloadUploadTradesCSVFile(csvData, filename);
        }


        $scope.closeModal = async function () {
            await $(".modal-backdrop").remove();
            $location.path("/wealthbaskets");
        }

        $scope.updateBrokerPopup = async function () {
            await $scope.prepareBrokerLinks($location.absUrl(), 'updateBrokerProfile', true, false);
            $('#updateBroker').modal({ backdrop: 'static', keyboard: false });
        }

        $scope.adviserProperty = function (adviserUsername, param) {
            if (adviserUsername in config.ADVISERSMETADATA)
                if (param in config.ADVISERSMETADATA[adviserUsername])
                    return config.ADVISERSMETADATA[adviserUsername][param];
            return undefined;
        }

        $scope.isAdviserPropertyEnabled = function (adviserUsername, param) {
            if (adviserUsername in config.ADVISERSMETADATA)
                if (param in config.ADVISERSMETADATA[adviserUsername])
                    return config.ADVISERSMETADATA[adviserUsername][param];
            return false;
        }

        $scope.getCAGR = function (data) {
            if (data)
                if ('fundReturnsComparison' in data) {
                    if (data.fundReturnsComparison.returnType == 'cagr') {
                        return data.fundReturnsComparison.returnPeriod + " CAGR";
                    } else {
                        return data.fundReturnsComparison.returnPeriod + " Abs. Return";
                    }
                }
            return "Abs. Return";
        }

        $scope.checkUploadTradeOfflineBroker = async function () {
            $scope.isOfflineBroker = await $scope.checkIsUserBrokerOffline();
            if ($scope.isOfflineBroker) {
                await WdHttpService._get_offline_trades(true)
                    .then(response => {
                        if ("pendingDetails" in response)
                            $scope.isUploadTradePending = response.pendingDetails.length > 0;
                    })
                    .catch(error => console.log(error));
            }
        }
    }
]);

function setUserSession(sessionService, response) {
    sessionService.set("id", JSON.stringify(response.data.authenticationResult.idToken));
    sessionService.set("auth", JSON.stringify(response.data.authenticationResult.accessToken));
    var expireIn = parseInt(response.data.authenticationResult.expiresIn) * 1000 + parseInt(new Date().getTime());
    sessionService.set("expiresIn", expireIn + "");
    if (response.data.authenticationResult.refreshToken)
        sessionService.set("refresh", JSON.stringify(response.data.authenticationResult.refreshToken));
}

function getProfileValueFor(key, data, breakRecursion = false) {
    var attributes = data.userAttributes;
    for (let index = 0; index < attributes.length; index++) {
        if (attributes[index]['name'] == key)
            return attributes[index]['value'];
    }

    if (key == "custom:brokerName1" && !breakRecursion) {
        return getProfileValueFor("custom:brokerName", data, true);
    }
    if (key == "custom:clientCode1" && !breakRecursion) {
        return getProfileValueFor("custom:clientCode", data, true);
    }
    if (key == "custom:brokerName" && !breakRecursion) {
        return getProfileValueFor("custom:brokerName1", data, true);
    }
    if (key == "custom:clientCode" && !breakRecursion) {
        return getProfileValueFor("custom:clientCode1", data, true);
    }
    return undefined;
}

function downloadUploadTradesCSVFile(orders, filename) {
    // Code reference from https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
    var headerString = 'stock,orderSide,exchange,quantity,price\r\n';
    createCSVAndDownload(orders, headerString, filename);
}

function createCSVAndDownload(dataArray, headerString, filename) {
    var csvContent = headerString;
    dataArray.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
    });
    var encodedUri = btoa(csvContent);
    var link = document.createElement("a");
    link.setAttribute("style", "display:none");
    link.setAttribute("href", 'data:application/octet-stream;base64,' + encodedUri);
    link.setAttribute("target", "_blank");
    link.setAttribute("download", filename);
    document.body.appendChild(link); // Required for FF
    link.click();
}

function stripHtml(html, charLenth = 0) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    if (charLenth > 0) {
        var trimmedString = tmp.textContent.substring(0, charLenth) || tmp.innerText.substring(0, charLenth);
        return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(".") != -1 ? trimmedString.lastIndexOf(".") : trimmedString.length)) || ""
    } else
        return tmp.textContent || tmp.innerText || "";
}

function prepareMetaDescription(html, charLenth = 150) {
    return stripHtml(html, charLenth);
}

function isFundRiskHigher(fundRisk, userRisk) {
    if (fundRisk == userRisk)
        return false;
    if (userRisk == 'HIGH' || (userRisk == 'MEDIUM' && fundRisk == 'LOW'))
        return false;
    return true;
}

function getDomain() {

    var full = window.location.host;
    var parts = full.split('.');
    var subdomain = parts[0];
    if (subdomain == 'wealthdesk') {
        if (parts.length > 2) {
            subdomain = parts[1];
        }
    }

    return subdomain;
}